import { useMemo, useState } from 'react'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
}

const INITIAL_STATE = {
  fotos: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedFoto: null,
}

export default function useModalFotosOcorrencias() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events
      onInit(fotos) {
        setState(prevState => ({ ...prevState, fotos }))
      },

      delete(foto) {
        setState(prevState => ({
          ...prevState,
          fotos: prevState.fotos.filter(f => f.id !== foto.id),
          selectedFoto: foto,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
